import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, Center, Flex, Spinner, VStack, Separator } from '@chakra-ui/react';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import ContentIntro from '@src/components/sco/Education/Other/ContentIntro';
import { VideoHero } from '@src/components/sco/Education/VideoLanding/VideoHero';
import { VideoListCarousel } from '@src/components/sco/Education/VideoLanding/VideoListCarousel';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { gql } from '@src/lib/gql';
import uniqBy from 'lodash/uniqBy';
import { useParams } from 'next/navigation';
import React, { useEffect, useState } from 'react';
type VideoLandingProps = {
  pageSize?: number;
  page?: number;
  filterCategory?: string;
};
export const VideoLanding: React.FC<VideoLandingProps> = props => {
  const $ = _c(25);
  const educationContext = useEducationContext();
  useParams();
  const [page] = useState(props.page || 1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [videos, setVideos] = useState(t0);
  const pageSize = props.pageSize || 24;
  let t1;
  if ($[1] !== props.filterCategory) {
    t1 = props.filterCategory ? {
      terms_some: {
        name: props.filterCategory
      }
    } : undefined;
    $[1] = props.filterCategory;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const filter = t1;
  let t2;
  if ($[3] !== educationContext) {
    t2 = () => {
      educationContext.setBreadcrumbs([{
        title: "Videos",
        href: "/videos"
      }]);
    };
    $[3] = educationContext;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useUniversalEffect(t2, t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = gql`
      query ($first: Int, $skip: Int, $where: VideoListWhereInput) {
        videoLists(first: $first, skip: $skip, where: $where, orderBy: publishedAt_DESC) {
          id
          slug
          featuredImage {
            id
            url(transformation: { image: { resize: { fit: max, width: 1000 } } })
          }
          shortDescription
          longDescription
          people {
            id
            firstName
            lastName
            title
            companyName
            companyLogo {
              id
              url
            }
            avatar {
              id
              url
            }
          }
          videos {
            id
            slug
            featuredImage {
              id
              url
            }
            videoPreviewUrl
          }
          title
          terms {
            id
            name
            slug
          }
        }
      }
    `;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = (page - 1) * pageSize;
  let t6;
  if ($[7] !== filter || $[8] !== pageSize || $[9] !== t5) {
    t6 = {
      variables: {
        first: pageSize,
        skip: t5,
        where: filter
      }
    };
    $[7] = filter;
    $[8] = pageSize;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const videoQuery = useQuery(t4, t6);
  let t7;
  if ($[11] !== videoQuery.data) {
    t7 = () => {
      if (videoQuery.data && videoQuery.data.videoLists) {
        setVideos(prev => uniqBy([...prev, ...videoQuery.data.videoLists], _temp));
      }
    };
    $[11] = videoQuery.data;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = videoQuery.data?.videoLists;
  let t9;
  if ($[13] !== t8) {
    t9 = [t8];
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  useEffect(t7, t9);
  let t10;
  if ($[15] !== videoQuery.loading) {
    t10 = videoQuery.loading && <Center height="70vh" padding="1em"><Spinner /></Center>;
    $[15] = videoQuery.loading;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== videoQuery.error) {
    t11 = videoQuery.error && <p>{"Error: "}{videoQuery.error.message}</p>;
    $[17] = videoQuery.error;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== videos) {
    t12 = videos && <Flex align="center" direction="column" gap={20} width="full"><VideoHero termSlugs={["featured"]} /><VStack align="flex-start" gap={0} width="full"><ContentIntro description="Get step-by-step instruction on how to build a startup from world-class Founders." title="Video Classes Led by Experts" /><VStack align="flex-start" gap={5} width="full"><Box padding={10} width="full"><VideoListCarousel term="strategy" videos={videos} /></Box><Separator borderColor="colorPalette.border" /><Box padding={10} width="full"><VideoListCarousel term="product-mvp" videos={videos} /></Box><Separator borderColor="colorPalette.border" /><Box padding={10} width="full"><VideoListCarousel term="funding" videos={videos} /></Box><Separator borderColor="colorPalette.border" /><Box padding={10} width="full"><VideoListCarousel term="customer-acquisition" videos={videos} /></Box><Separator borderColor="colorPalette.border" /><Box padding={10} width="full"><VideoListCarousel term="recruiting" videos={videos} /></Box></VStack></VStack></Flex>;
    $[19] = videos;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t12) {
    t13 = <VStack align="center" gap={10} justify="stretch" marginBottom={20} width="full">{t10}{t11}{t12}</VStack>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
};
function _temp(x) {
  return x.id;
}